import React from "react";
import { useSelector } from "react-redux";
import SuggestionBox from "../../../common/suggestionBox/SuggestionBox";
import Summary from "../../../components/yourAssets/BOA/securities/Summary";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";

const Securities = ({ next, back, tabText }) => {
  const updates = useSelector((state) => state.auditTrail.updates);

  return (
    <>
      <Summary next={next} back={back} updates={updates} />
      <SuggestionBox
        mainText={tabText}
        tabName="Securities"
        setVisited={visited}
      />
    </>
  );
};

export default Securities;
